var _rect, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 660,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 660,
    height: 480,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 660,
    height: 75,
    y: 45,
    fill: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 660,
    height: 75,
    y: 360,
    fill: "#000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.694,172.92A99.306,99.306 0 1,0 429.306,172.92H419.851A89.851,89.851 0 1,1 240.149,172.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.256,173.35A70.744,70.744 0 1,0 400.744,173.35H391.223A61.223,61.223 0 1,1 268.777,173.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.157,172.92A41.843,41.843 0 1,0 371.843,172.92H362.388A32.388,32.388 0 1,1 297.612,172.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.562,317.879V324.35H381.438V317.879L334.727,307.466V165.639H325.273V307.466z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M223.357,161.017H247.489L240.151,170.934H230.696z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 28.731
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 57.461
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    x: 94.577,
    y: -7.261
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3",
    x: 131.693
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYd);
export default __webpack_public_path__ + "static/media/yd.e84bc8de47bfcfc0f8d5d27013279371.svg";
export { ForwardRef as ReactComponent };